import exception from '@/handlers/exception.js'
import Api from "@/services/api";

class Authentication {

    getAccess(data) {
        switch (data.role) {
            case 'manager':
                return { role: 'manager', permission: 'manager' };
            case 'finance':
                return { role: 'manager', permission: 'finance' };
            case 'customer':
                return { role: 'customer', permission: 'customer' };
            default:
                return { role: false, permission: false };
        }
    }

    createUser(data) {
        const access = this.getAccess(data);
        const user = {
            id: data.id,
            name: data.name,
            role: access.role,
            permission: access.permission,
            token: data.token,
        };

        if (data.role == 'customer') {
            user.company_id = data.companies[data.companies.length - 1];
            user.companies = data.companies;
            user.company_names = data.company_names;
        }

        return user;
    }

    saveUser(data) {
        localStorage.user = JSON.stringify(this.createUser(data));
    }

    async handleLogoutRequest(request) {
        await request.then(({
            data
        }) => {
            return exception.logout(data)
        }).catch(error => {
            return exception.logout(error)
        });

        return true
    }

    isAuthenticated() {
        return localStorage.user ? JSON.parse(localStorage.user) : false;
    }

    async logIn(jsonCredentials) {

        if (typeof (jsonCredentials['username']) == 'undefined' || jsonCredentials['username'].length < 3) {
            return false;
        }

        if (typeof (jsonCredentials['password']) == 'undefined' || jsonCredentials['password'].length < 3) {
            return false;
        }

        let result = false

        await Api.auth("login", jsonCredentials).then(({
            data
        }) => {
            this.saveUser(data)
            result = true
        }).catch(error => {
            result = exception.login(error);
        });

        return result
    }

    async loginWithToken(token) {
        await Api.auth("refresh", token).then(({
            data
        }) => {
            this.saveUser(data)

            location.reload();
        }).catch(error => {
            return exception.login(error)
        });
    }

    async logOut() {
        return this.handleLogoutRequest(Api.auth("logout"));
    }

    async sendVerification(jsonEmail) {
        return this.handleLogoutRequest(Api.auth("email/resend", jsonEmail));
    }

    clearStorage() {
        localStorage.removeItem('user');
    }
}

const Auth = new Authentication();

export default Auth
